import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import GoogleIcon from '../../../../assets/images/register/icon-google.png';
import RaiseFxIcon from '../../../../assets/images/register/icon-raisefx.png';
import { registerColors } from '../../styles/colors';

interface ThirdPartyAuthButtonsProps {
  onGoogleClick?: () => void;
  onRaiseFxClick?: () => void;
  googleButtonText: string;
  raiseFxButtonText?: string;
}

const buttonSx = {
  backgroundColor: registerColors.backgroundButton,
  color: 'white',
  borderRadius: '50px',
  border: `1px solid ${registerColors.backgroundButton}`,
  fontSize: '15px',
  whiteSpace: 'nowrap' as const,
};

// Each provider is offered only when its build-time configuration is present.
const googleEnabled = Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim());
const raiseFxEnabled = Boolean(process.env.REACT_APP_RFX_AUTH_URL?.trim());

const ThirdPartyAuthButtons: React.FC<ThirdPartyAuthButtonsProps> = ({
  onGoogleClick,
  onRaiseFxClick,
  googleButtonText,
  raiseFxButtonText,
}) => {
  if (!googleEnabled && !raiseFxEnabled) {
    return null;
  }
  return (
    <Stack direction="row" gap={2} sx={{ mb: 2, alignSelf: 'center' }}>
      {googleEnabled && (
        <Button variant="outlined" size="medium" onClick={onGoogleClick} sx={buttonSx}>
          <Stack direction="row" gap={1.5} alignItems="center">
            <Box component="img" src={GoogleIcon} width="28px" height="28px" />
            {googleButtonText}
          </Stack>
        </Button>
      )}

      {/* RaiseFX sign-in is retired until after the migration: the button only renders for a
          caller that actually wires a handler. See the branch that restores it. */}
      {raiseFxEnabled && onRaiseFxClick && (
        <Button variant="outlined" size="medium" onClick={onRaiseFxClick} sx={buttonSx}>
          <Stack direction="row" gap={1.5} alignItems="center">
            <Box component="img" src={RaiseFxIcon} width="22px" height="22px" />
            {raiseFxButtonText}
          </Stack>
        </Button>
      )}
    </Stack>
  );
};

export default ThirdPartyAuthButtons;
